import { create } from 'zustand';

import { ICrossSellerPaymentForm } from '../schemas';

export type ICrossSellerStatePaymentForm = ICrossSellerPaymentForm;

interface ICrossSellerState {
  paymentForm: ICrossSellerStatePaymentForm;
  setPaymentForm: (CrossSellerState: ICrossSellerStatePaymentForm) => void;
}

export const usePaymentState = create<ICrossSellerState>(set => {
  return {
    paymentForm: sessionStorage.getItem('paymentForm')
      ? JSON.parse(sessionStorage.getItem('paymentForm')!)
      : ({ paymentCard: 'newCard' } as ICrossSellerStatePaymentForm),
    setPaymentForm(newPaymentForm: ICrossSellerStatePaymentForm) {
      set({ paymentForm: newPaymentForm });
      sessionStorage.setItem('paymentForm', JSON.stringify(newPaymentForm));
    },
  };
});
